export default {
  help: "Help",
  addHelp: "AddHelp",
  editHelp: "EditHelp",
};
